import React from 'react';
import { Settings as SettingsIcon, ChevronDown } from 'lucide-react';
import { Config } from '../types';

interface SettingsProps {
    config: Config;
    onConfigUpdate: (updates: Partial<Config>) => void;
    isOpen: boolean;
    onToggle: () => void;
}

const Settings: React.FC<SettingsProps> = ({ config, onConfigUpdate, isOpen, onToggle }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border">
            <button
                onClick={onToggle}
                className="w-full flex items-center justify-between p-4 cursor-pointer transition-colors"
            >
                <div className="flex items-center gap-3">
                    <SettingsIcon size={20} className="text-blue-600"/>
                    <span className="font-medium text-gray-800">تنظیمات اصلی</span>
                </div>
                <ChevronDown
                    size={20}
                    className={`text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            {isOpen && (
                <div className="border-t p-6 space-y-4">
                    <div className="grid md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                عنوان پروژه
                            </label>
                            <input
                                type="text"
                                value={config.title}
                                onChange={(e) => onConfigUpdate({ title: e.target.value })}
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                placeholder="عنوان پروژه"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                موقعیت لیست
                            </label>
                            <select
                                value={config.list_type}
                                onChange={(e) => {
                                    const newListType = e.target.value as 'side' | 'bottom';
                                    onConfigUpdate({
                                        list_type: newListType,
                                        type: newListType === 'side' ? 'square' : config.type
                                    });
                                }}
                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm"
                            >
                                <option value="side">کناری</option>
                                <option value="bottom">پایین</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                نوع نمایش
                            </label>
                            <select
                                value={config.type}
                                onChange={(e) => onConfigUpdate({ type: e.target.value as 'square' | 'rectangle' })}
                                disabled={config.list_type === 'side'}
                                className={`w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 text-sm ${
                                    config.list_type === 'side'
                                        ? 'border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed'
                                        : 'border-gray-300'
                                }`}
                            >
                                <option value="square">مربع</option>
                                <option value="rectangle">مستطیل</option>
                            </select>
                            {config.list_type === 'side' && (
                                <p className="text-xs text-gray-500 mt-1">
                                    در حالت کناری: مربع
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Settings; 